import { render, staticRenderFns } from "./cmp-left-bottom.vue?vue&type=template&id=8b09d408&scoped=true"
import script from "./cmp-left-bottom.vue?vue&type=script&lang=js"
export * from "./cmp-left-bottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b09d408",
  null
  
)

export default component.exports